<template>
  <div>
    <div v-if="single" class="select">
      <select v-model="filters[filter]">
        <option :value="null">
          Alle
        </option>
        <option
          v-for="option in optionsWithIds"
          :key="option._id"
          :value="option._id"
        >
          {{ option.title }}{{ suffix }}
        </option>
      </select>
      <button type="button" v-if="filters[filter]" @click="resetFilter(filter)">
        <SvgIcon icon="clear" />
      </button>
      <p v-if="!filters[filter] && selection.length !== options.length">
        {{ selection.length }} von {{ options.length }}
      </p>
      <span v-if="!filters[filter]">
        <SvgIcon icon="arrow-down" />
      </span>
    </div>
    <div v-else class="checkboxes">
      <template v-for="option in optionsWithIds">
        <input
          type="checkbox"
          :id="`season-${option._id}`"
          :value="option._id"
          :key="`input-${option._id}`"
          v-model="filters[filter]"
        />
        <label
          :key="`label-${option._id}`"
          :for="`season-${option._id}`"
          :class="{
            'is-only': isOnlySelectedOption(option),
            'is-disabled': isDisabledOption(option)
          }"
        >
          {{ option.title }}{{ suffix }}
        </label>
      </template>
      <button
        type="button"
        :disabled="!filters[filter].length"
        @click="resetCheckboxFilter(filter)"
      >
        Alle
      </button>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

import SvgIcon from '@/components/SvgIcon'

export default {
  name: 'FilterSelect',
  props: {
    filter: {
      type: String,
      required: true
    },
    options: {
      type: Array,
      required: true,
      default: () => []
    },
    suffix: {
      type: String,
      required: false,
      default: ''
    },
    selection: {
      required: false,
      default: () => []
    },
    multi: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  components: { SvgIcon },
  computed: {
    ...mapState(['filters']),
    filterState() {
      return this.filters[this.filter]
    },
    single() {
      return !this.multi
    },
    optionsWithIds() {
      return this.options.map((option) => {
        if (typeof option !== 'object') {
          return { _id: option || null, title: option }
        }
        return option
      })
    },
    selectionIds() {
      return this.selection ? this.selection.map((s) => s._id || s) : []
    }
  },
  methods: {
    resetFilter(filter) {
      this.filters[filter] = null
    },
    resetCheckboxFilter(filter) {
      this.filters[filter] = []
    },
    isOnlySelectedOption(option) {
      const filterState = this.filters[this.filter]
      return filterState.length === 1 && filterState[0] === option._id
    },
    isDisabledOption(option) {
      return this.selection !== false && !this.selectionIds.includes(option._id)
    }
  }
}
</script>

<style scoped>
div {
  position: relative;
}
select {
  position: relative;
  @mixin type-large;
  @mixin type-medium-lineheight;
  margin-top: -0.15em;
  border-bottom: 1px solid;
  width: calc(100% + var(--filter-label-width));
  margin-left: calc(-1 * var(--filter-label-width) - 1px);
  padding-left: var(--filter-label-width);
  padding-right: 0.75em;
  text-overflow: ellipsis;
}
.select button {
  position: absolute;
  top: 45%;
  right: 0;
  transform: translateY(-50%);
}
/deep/ .select .icon-clear {
  transform: translateY(-8%);
}
/deep/ .select .icon-arrow-down {
  position: absolute;
  top: 40%;
  right: 0;
  transform: translateY(-50%);
  pointer-events: none;
}
option {
  font-size: 1rem;
}
p {
  position: absolute;
  left: 0;
  padding-left: 3rem;
  bottom: 0;
  pointer-events: none;
  color: var(--color-text-light);
}
label {
  display: inline-block;
  padding-right: 0.65em;
  @mixin type-large;
  @mixin type-medium-lineheight;
  vertical-align: baseline;
  &.is-only {
    pointer-events: none;
  }
  &.is-disabled {
    color: var(--color-text-light);
  }
}
input[type='checkbox'] {
  position: absolute !important;
  width: 1px;
  height: 1px;
  margin: -1px;
  padding: 0;
  overflow: hidden;
  clip: rect(0 0 0 0);
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}
input[type='checkbox'] + label {
  cursor: pointer;
  &:hover {
    opacity: 0.6;
  }
}
input[type='checkbox']:checked + label {
  color: var(--color-highlight);
  opacity: 1;
  &.is-disabled {
    color: var(--color-highlight-light);
  }
}
button[type='button'] {
  @mixin type-large;
  @mixin type-medium-lineheight;
  vertical-align: baseline;
  &:disabled {
    color: var(--color-highlight);
    cursor: default;
  }
}
@mixin breakpoint-small {
  label {
    padding-right: 0.8em;
  }
}
@media only print {
  select {
    border-width: 0;
  }
  /deep/ .select {
    svg,
    button {
      display: none;
    }
  }
  input[type='checkbox']:not(:checked) {
    display: none;
    & + label {
      display: none;
    }
  }
  button:not([disabled]) {
    display: none;
  }
}
</style>
